import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChangePasswordLandingPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChangePasswordLandingPageQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', isManagedUser?: boolean | null } | null };


export const ChangePasswordLandingPageDocument = gql`
    query ChangePasswordLandingPage {
  currentUser {
    isManagedUser
  }
}
    `;

/**
 * __useChangePasswordLandingPageQuery__
 *
 * To run a query within a React component, call `useChangePasswordLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangePasswordLandingPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangePasswordLandingPageQuery(baseOptions?: Apollo.QueryHookOptions<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>(ChangePasswordLandingPageDocument, options);
      }
export function useChangePasswordLandingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>(ChangePasswordLandingPageDocument, options);
        }
// @ts-ignore
export function useChangePasswordLandingPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>): Apollo.UseSuspenseQueryResult<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>;
export function useChangePasswordLandingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>): Apollo.UseSuspenseQueryResult<ChangePasswordLandingPageQuery | undefined, ChangePasswordLandingPageQueryVariables>;
export function useChangePasswordLandingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>(ChangePasswordLandingPageDocument, options);
        }
export type ChangePasswordLandingPageQueryHookResult = ReturnType<typeof useChangePasswordLandingPageQuery>;
export type ChangePasswordLandingPageLazyQueryHookResult = ReturnType<typeof useChangePasswordLandingPageLazyQuery>;
export type ChangePasswordLandingPageSuspenseQueryHookResult = ReturnType<typeof useChangePasswordLandingPageSuspenseQuery>;
export type ChangePasswordLandingPageQueryResult = Apollo.QueryResult<ChangePasswordLandingPageQuery, ChangePasswordLandingPageQueryVariables>;